/**
 * Alive Water — Benefits carousel
 * Classic transform-based carousel with mouse/touch drag + dots pagination.
 */
(function () {
  'use strict';

  function init(section) {
    if (section.__aliveBenefitsInit) return;
    section.__aliveBenefitsInit = true;

    var viewport = section.querySelector('[data-viewport]');
    var track = section.querySelector('[data-track]');
    if (!viewport || !track) {
      console.warn('[alive-benefits] viewport or track missing');
      return;
    }

    var items = Array.prototype.slice.call(track.children);
    if (items.length === 0) {
      console.warn('[alive-benefits] no items in track');
      return;
    }

    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-dot]'));
    console.log('[alive-benefits] init:', items.length, 'items,', dots.length, 'dots');

    var currentIndex = 0;
    var currentOffset = 0;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var dragMoved = false;

    function stepSize() {
      if (items.length < 2) return 0;
      var a = items[0].getBoundingClientRect();
      var b = items[1].getBoundingClientRect();
      return b.left - a.left;
    }

    function minOffset() {
      var trackW = track.scrollWidth;
      var viewportW = viewport.clientWidth;
      return Math.min(0, viewportW - trackW);
    }

    function setTransform(px) {
      currentOffset = px;
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
    }

    function setAnimated(on) {
      if (on) track.classList.remove('no-anim');
      else track.classList.add('no-anim');
    }

    function goTo(i, animate) {
      var maxI = items.length - 1;
      if (i < 0) i = 0;
      if (i > maxI) i = maxI;
      currentIndex = i;

      var target = -i * stepSize();
      var minO = minOffset();
      if (target < minO) target = minO;

      setAnimated(animate !== false);
      setTransform(target);
      updateDots();
    }

    function updateDots() {
      for (var i = 0; i < dots.length; i++) {
        var active = i === currentIndex;
        dots[i].classList.toggle('is-active', active);
        dots[i].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    // --- Dots click ---
    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function (e) {
          e.preventDefault();
          console.log('[alive-benefits] dot click:', idx);
          goTo(idx, true);
        });
      })(i);
    }

    // --- Drag shared handlers ---
    function dragStart(clientX) {
      isDragging = true;
      dragMoved = false;
      dragStartX = clientX;
      dragStartOffset = currentOffset;
      setAnimated(false);
      viewport.classList.add('is-dragging');
    }

    function dragMove(clientX) {
      if (!isDragging) return;
      var dx = clientX - dragStartX;
      if (Math.abs(dx) > 4) dragMoved = true;
      var next = dragStartOffset + dx;
      var minO = minOffset();
      if (next > 0) next = next * 0.3;
      else if (next < minO) next = minO + (next - minO) * 0.3;
      setTransform(next);
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      if (dragMoved) {
        var step = stepSize();
        var snap = step > 0 ? Math.round(-currentOffset / step) : 0;
        goTo(snap, true);
      } else {
        setAnimated(true);
      }
    }

    // --- Mouse events ---
    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragStart(e.clientX);
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      dragMove(e.clientX);
    });

    document.addEventListener('mouseup', function () {
      dragEnd();
    });

    // --- Touch events ---
    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      dragStart(e.touches[0].clientX);
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      dragMove(e.touches[0].clientX);
    }, { passive: true });

    viewport.addEventListener('touchend', dragEnd);
    viewport.addEventListener('touchcancel', dragEnd);

    // --- Block clicks that follow a drag ---
    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.stopPropagation();
        e.preventDefault();
        dragMoved = false;
      }
    }, true);

    // --- Resize ---
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goTo(currentIndex, false);
      }, 120);
    });

    // --- Init (no animation so it lands without flash) ---
    goTo(0, false);
    // Re-enable animation after first paint
    requestAnimationFrame(function () {
      setAnimated(true);
    });
  }

  function boot() {
    var sections = document.querySelectorAll('[data-alive-benefits]');
    for (var i = 0; i < sections.length; i++) {
      init(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-alive-benefits]')) {
      init(t);
    } else if (t && t.querySelector) {
      var nested = t.querySelector('[data-alive-benefits]');
      if (nested) init(nested);
    }
  });
})();
